import { ApiResource } from "./apiResource";
import axios from "axios";

interface ValidationCertificationSign {
  externalCertificateId: number;
  password: string;
}

interface ExcuteCertificateParams {
  externalCertificateId: number;
  imageId: number;
  password: string;
}

export class CertificateApi extends ApiResource {
  async getCertificateConfig() {
    return axios.get(`${this.endpoint}/certificate/config`, {
      headers: this.buildHeaders(),
    });
  }

  async validationCertificateSign(params: ValidationCertificationSign) {
    return axios.put(`${this.endpoint}/certificate/sign/validation`, params, {
      headers: this.buildHeaders(),
    });
  }

  async excuteCertificate(params: ExcuteCertificateParams) {
    return axios.put(`${this.endpoint}/certificate/sign`, params, {
      headers: this.buildHeaders(),
    });
  }
}
